"use strict";

import { __init } from "..";

import { CONSTANTS } from "~/helpers/constants";

import { activateCategory } from "~/block/listeners";
import { clearCookieStorage, saveConsentState } from "~/block/cookie";
import { destroyBanner } from "~/helpers";

// Initialize the cookiedock object on the window
if (typeof window !== "undefined" && !window.cookiedock) {
  const cookiedockObject = {
    // Public API methods (will be implemented properly later)
    open: function open() {},
    close: function close() {},
    acceptAll: function acceptAll() {},
    declineAll: function declineAll() {},
    savePreferences: function savePreferences() {},
    showDetails: function showDetails() {},
    hideDetails: function hideDetails() {},
    togglePreference: function togglePreference() {},
    toggleCookie: function toggleCookie() {},
    setLanguage: function setLanguage() {},

    // Internal properties (prefixed with __)
    __version: CONSTANTS.VERSION,
    __mock: false,
    __cookies: {
      rejected: [],
      content: null,
    },
    __consent: {},
    __listeners: {
      analytics: [],
      marketing: [],
      functional: [],
      unknown: [],
    },
    __cookie_purposes: [],
    __pendingListeners: [],
    __allowed_event: null,
    __cookieInterceptorActive: false,
    __originalWindowAddEventListener: window.addEventListener,
    __originalDocAddEventListener: document.addEventListener,
    __activateCategory: function __activateCategory() {},
  };

  // Create static storage using Object.freeze
  window.cookiedock = Object.freeze(cookiedockObject);
}

/**
 * Public API to reset consent and reopen banner
 */
("@keep");
window.cookiedock.open = function () {
  destroyBanner();
  clearCookieStorage();
  window.cookiedock.__consent = {};

  __init();
};

/**
 * Public API to close the consent banner
 */
("@keep");
window.cookiedock.close = function () {
  const element = document.querySelector(`.${CONSTANTS.BANNER.SELECTOR}`);
  if (element) element.remove();
};

/**
 * Public API to accept all cookie categories
 */
("@keep");
window.cookiedock.acceptAll = function () {
  // TODO: Implement this Lets make a the window.cookiedock a better storage object

  // api.post(`api/v1/${cuuid}/consent`, {
  //   body: {
  //     cookie_purposes: {
  //       analytics: {
  //         approved: true,
  //       },
  //       marketing: {
  //         approved: true,
  //       },
  //       functional: {
  //         approved: true,
  //       },
  //       unknown: {
  //         approved: true,
  //       },
  //     },
  //   },
  // });

  if (!window.cookiedock.__consent) {
    window.cookiedock.__consent = {};
  }

  Object.values(CONSTANTS.CATEGORIES).forEach((category) => {
    window.cookiedock.__consent[category] = true;
    activateCategory(category);
  });

  saveConsentState(window.cookiedock.__consent);
  window.cookiedock.close();
};

/**
 * Public API to decline all optional cookie categories
 */
("@keep");
window.cookiedock.declineAll = function () {
  if (!window.cookiedock.__consent) {
    window.cookiedock.__consent = { unknown: true };
  } else {
    Object.values(CONSTANTS.CATEGORIES).forEach((category) => {
      if (category !== "unknown") {
        window.cookiedock.__consent[category] = false;
      }
    });
  }

  saveConsentState(window.cookiedock.__consent);
  window.cookiedock.close();
};

/**
 * Public API to save user preferences
 */
("@keep");
window.cookiedock.savePreferences = function () {
  if (window.cookiedock.__consent) {
    saveConsentState(window.cookiedock.__consent);
    window.cookiedock.close();
  }
};

/**
 * Public API to show the details dialog
 */
("@keep");
window.cookiedock.showDetails = function () {
  const dialog = document.getElementById("cdx__dialog") as HTMLDialogElement;
  if (dialog) {
    dialog.showModal();
  }
};

/**
 * Public API to hide the details dialog
 */
("@keep");
window.cookiedock.hideDetails = function () {
  const dialog = document.getElementById("cdx__dialog") as HTMLDialogElement;
  if (dialog) {
    dialog.close();
  }
};

/**
 * Public API to toggle a preference category
 */
("@keep");
window.cookiedock.togglePreference = function (category) {
  if (!window.cookiedock.__consent) {
    window.cookiedock.__consent = { unknown: true };
  }

  window.cookiedock.__consent[category] = !window.cookiedock.__consent[category];

  if (window.cookiedock.__consent[category]) {
    activateCategory(category);
  }
};

/**
 * Public API to toggle a specific cookie
 */
("@keep");
window.cookiedock.toggleCookie = function (cookieName: string) {
  // This would need cookie-specific control which may not be implemented yet
  console.warn("Cookie-specific control not implemented yet:", cookieName);
};

/**
 * Public API to set the language
 */
("@keep");
window.cookiedock.setLanguage = function (language) {
  if (window.cookiedock.__cookies && window.cookiedock.__cookies.content) {
    const content = window.cookiedock.__cookies.content;
    if (content.language) {
      content.language.alpha2 = language;
    }
  }
};
